module.exports = __webpack_public_path__ + "img/plane-svgrepo-com.b282f5e5.svg";